var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "modal_wrap" }, on: { click: _vm.onClose } },
    [
      _c("div", { staticClass: "modal_container" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "modal_header" }, [
          _c("h4", [_vm._v(_vm._s(_vm.modalData.header))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal_body" }, [_vm._t("default")], 2),
        _vm._v(" "),
        _c("div", { staticClass: "modal_footer" }),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "swal2-header" }, [
      _c("div", {
        staticClass: "swal2-icon swal2-info swal2-animate-info-icon",
        staticStyle: { display: "flex" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }